/**
 * @fileoverview Root Redux reducer that combines all feature reducers.
 * 
 * This file imports and combines all feature-level reducers into a single
 * root reducer using Redux's combineReducers utility.
 * 
 * State Structure:
 * - app: Core application state (CSA data, initialization)
 * - auth: Authentication and permissions
 * - Summary features: csaSummary, csaDrilldown, impactchart, monitoringSummary
 * - Impact analysis: impactAnalysis
 * - Static data: staticDataIsda, staticDataMappings, staticDataGeneral
 * - Admin: admin, webJobs, webJobsDetails, imCalculation, fileAvailability
 * - Commodity: commodityReport, commodityJobs, commodityJobsDetails
 * - Other: independentAmount, settings
 * - UI: filterHeader, notifications
 * 
 * @module rootReducer
 */

import { combineReducers } from 'redux';
import { reducer as notifications } from 'react-notification-system-redux';
import filterHeaderReducer from './webcommon/header/filterheader/reducer';
import appReducer from './app/reducer';
import csaSummaryReducer from './summary/csasummary/reducer';
import csaDrilldownReducer from './summary/csadrilldown/reducer';
import impactchart from './summary/impactchart/reducer';
import monitoringSummary from './summary/monitoringSummary/reducer';
import impactAnalysisReducer from './impactanalysis/reducer';
import staticDataIsdaReducer from './staticdata/staticdataisda/reducer';
import commodityReportReducer from './commodityReport/reducer';
import staticDataMappingsReducer from './staticdata/staticdatamappings/reducer';
import staticDataGeneral from './staticdata/staticdatageneral/reducer';
import webJobsReducer from './admin/webjobs/DataLoads/reducer';
import webJobsDetailsReducer from './admin/webjobs/DataDetails/reducer';
import imCalculationReducer from './admin/imcalculation/reducer';
import auth from './auth/reducer';
import impactAnalysisIdSummaryGrid from './admin/impactAnalysisIdSummary/reducer';
import commodityJobsReducer from './commodityReport/triggerJobs/DataLoads/reducer'
import commodityJobsDetailsReducer from './commodityReport/triggerJobs/DataDetails/reducer'
import fileAvailabilityReducer from './admin/fileAvailability/reducer'
import independentAmountReducer from './independentAmount/reducer'
import settingsReducer from './settings/reducer'
import admin from './admin/reducer';


/**
 * Root reducer combining all feature reducers.
 * 
 * @type {Function}
 * @returns {Object} Combined state object with all feature slices
 * 
 * @example
 * // In index.jsx
 * import rootReducer from './rootReducer';
 * import { connectRouter } from 'connected-react-router';
 * 
 * const store = createStore(
 *   connectRouter(history)(rootReducer),
 *   initialState,
 *   enhancers
 * );
 * 
 * @example
 * // State shape
 * {
 *   app: { ... },
 *   auth: { ... },
 *   csaSummary: { ... },
 *   // ... other feature slices
 * }
 */
export default combineReducers({
    filterHeader: filterHeaderReducer,
    app: appReducer,
    csaSummary: csaSummaryReducer,
    csaDrilldown: csaDrilldownReducer,
    impactchart,
    monitoringSummary,
    notifications,
    impactAnalysis: impactAnalysisReducer,
    staticDataIsda: staticDataIsdaReducer,
    commodityReport: commodityReportReducer,
    fileAvailability: fileAvailabilityReducer,
    staticDataMappings: staticDataMappingsReducer,
    staticDataGeneral,
    webJobs: webJobsReducer,
    commodityJobs: commodityJobsReducer,
    imCalculation: imCalculationReducer,
    webJobsDetails: webJobsDetailsReducer,
    commodityJobsDetails: commodityJobsDetailsReducer,
    impactAnalysisIdSummaryGrid,
    auth,
    independentAmount: independentAmountReducer,
    settings: settingsReducer,
    admin
});
